import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

export interface TestemunhoItem {
  id: number;
  utilizadorID?: string;
  utilizadorNome?: string;
  utilizadorEmail?: string;
  utilizadorAnonimo?: boolean;
  utilizadorNomeAnonimo?: string;
  estrelas: number;
  descricao: string;
  dataCriacao?: string;
  ativo: boolean;
}

export interface TestemunhoDto {
  id?: number;
  utilizadorID?: string;
  estrelas: number;
  descricao: string;
}

@Injectable({
  providedIn: 'root',
})
export class TestemunhoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) {}

  /**
   * Listar testemunhos com filtros opcionais e paginação
   */
  list(params?: any): Observable<any> {
    let httpParams = new HttpParams();

    if (params) {
      Object.keys(params).forEach((key) => {
        const val = params[key];
        if (val !== null && val !== undefined && val !== '') {
          httpParams = httpParams.set(key, val);
        }
      });
    }

    return this.apiService.get('/Testemunho', httpParams).pipe(
      map((response) => response),
    );
  }

  /**
   * Obter detalhes de um testemunho por ID
   */
  show(id: number | string): Observable<any> {
    return this.apiService.get(`/Testemunho/${id}`).pipe(
      map((response) => response),
    );
  }

  /**
   * Criar um novo testemunho
   */
  store(data: TestemunhoDto): Observable<any> {
    return this.apiService.post('/Testemunho', data);
  }

  /**
   * Atualizar um testemunho existente
   */
  update(data: TestemunhoDto): Observable<any> {
    return this.apiService.put('/Testemunho', data);
  }

  /**
   * Ativar / Desativar status do testemunho
   */
  toggleStatus(id: number | string): Observable<any> {
    return this.apiService.patch(`/Testemunho/${id}`);
  }

  /**
   * Excluir um testemunho
   */
  delete(id: number | string): Observable<any> {
    return this.apiService.delete(`/Testemunho/${id}`);
  }
}
